import { FunctionComponent, useState } from "react";

import BasicButton from "@components/core/buttons/BasicButton";
import LoadImageField from "@components/core/inputs/LoadImageField";
import HandwritteSignatureModal from "@components/core/modals/HandwrittenSignatureModal";
import { EditOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { SignaturePicturePriorityEnum } from "@utils/enums/signature.picture.priority.enum";
import { SignaturePicturesProps } from "@components/core/subComponents/signature/SignaturePicture";

const SignatureHandwrittenPicture: FunctionComponent<
  SignaturePicturesProps
> = ({
  signaturePictures,
  onUpdatePicture,
  onDeletePicture,
  onSetDefaultPicture,
}) => {
  const { t } = useTranslation();

  const [
    handwrittenSignatureModalVisible,
    setHandwrittenSignatureModalVisible,
  ] = useState<boolean>(false);

  return (
    <div>
      <div className="row-gap-m">
        {signaturePictures?.map((signaturePicture, index) => (
          <div
            key={`DrawImageField_SignatureHandwrittenPicture_${index}`}
            className="column-align-items-center"
          >
            <LoadImageField
              imgSrc={signaturePicture.picture}
              onClick={() => setHandwrittenSignatureModalVisible(true)}
              onDelete={() =>
                onDeletePicture(
                  SignaturePicturePriorityEnum.PERSONAL_PICTURE,
                  signaturePicture.rank,
                )
              }
              isSelected={signaturePicture.isDefault}
              loadIcon={<EditOutlined />}
              loadText={t(
                "account.mySignature.signaturePicture.signatureHandwrittenPicture.button",
              )}
              isSignatureImage
            />
            <HandwritteSignatureModal
              visible={handwrittenSignatureModalVisible}
              onCancel={() => setHandwrittenSignatureModalVisible(false)}
              onSubmit={(file: File) =>
                onUpdatePicture(signaturePicture.rank, file)
              }
            />
            <div className="mt-16">
              {
                // if there is no picture it means that there was no signature picture for this rank
                signaturePicture.picture != "" &&
                  (signaturePicture.isDefault ? (
                    <span>
                      {t("account.mySignature.signaturePicture.selected")}
                    </span>
                  ) : (
                    <BasicButton
                      text={t("account.mySignature.signaturePicture.select")}
                      onClick={() =>
                        onSetDefaultPicture?.(
                          SignaturePicturePriorityEnum.PERSONAL_PICTURE,
                          signaturePicture.rank,
                        )
                      }
                    />
                  ))
              }
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SignatureHandwrittenPicture;
